export { ReactComponent as ImageUpload } from './svgs/image-upload.svg';
